import React, { createContext, useContext, useMemo, useState } from 'react'

const BranchContext = createContext(null)

const useSelectedBranch = () => {
  const context = useContext(BranchContext)
  if (!context) {
    throw new Error('useCount must be used within a BranchProvider')
  }
  return context
}

const SelectedBranchProvider = props => {
  const [selectedBranch, setSelectedBranch] = useState(null)

  const value = useMemo(() => ({ selectedBranch, setSelectedBranch }), [selectedBranch])
  return <BranchContext.Provider value={value} {...props} />
}

export { SelectedBranchProvider, useSelectedBranch }
